<!--
	Side-panel section with a title and collapse toggle; hosts the attributes
	and countermeasures panes.
-->
<script lang="ts">
	import type { Snippet } from 'svelte';
	import CollapseToggleButton from './CollapseToggleButton.svelte';

	interface Props {
		title: string;
		/** Grows into the remaining side-panel height (e.g. under the attributes). */
		grow?: boolean;
		/** Drops the grey panel background. */
		transparent?: boolean;
		/** Rendered beside the title. */
		titleExtra?: Snippet;
		children: Snippet;
	}

	const { title, grow = false, transparent = false, titleExtra, children }: Props = $props();

	let collapse = $state(false);
</script>

<div class="panel" class:grow class:transparent>
	<div class="header">
		<div class="titleGroup">
			<h2 class="overline">{title}</h2>
			{@render titleExtra?.()}
		</div>
		<CollapseToggleButton
			collapsed={collapse}
			aria-label="Toggle {title}"
			oncollapsetoggle={() => (collapse = !collapse)} />
	</div>

	{#if !collapse}
		<div class="container">
			{@render children()}
		</div>
	{/if}
</div>

<style>
	.panel {
		display: flex;
		flex-direction: column;
		background-color: var(--surface-alt);
		height: fit-content;
		overflow: hidden;

		&.transparent {
			background-color: transparent;
		}

		&.grow {
			flex: 1 0 var(--space-8);
			height: auto;
			min-height: var(--space-8);
			max-height: min-content;

			.container {
				padding: 0 var(--space-2);

				@media screen and (min-width: 1400px) {
					padding-inline: var(--space-4) var(--space-5);
				}
			}
		}
	}

	.header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: var(--space-2) var(--space-2) var(--space-1) var(--space-4);

		h2 {
			font-size: var(--font-size-base);
		}

		.titleGroup {
			display: flex;
			align-items: baseline;
			gap: var(--space-2);
		}
	}

	.container {
		height: 100%;
		overflow-y: auto;
	}
</style>
